export const APP_ID = `LJQYV52FYP`
export const API_KEY = `cfa98ac7b754fc728c259efac402121d`

export const HITS_PER_RESULTS = 20

export const ALGOLIA_COLLECTION_FILTER_RULES = `inventory_quantity >= 1 AND NOT named_tags.assetcondition:NA AND NOT named_tags.assetcondition:PREORDER`

// Config Object to determine which indices should be used throughout the shopify stores.
const algoliaShopifyIndices = {
  'silverchef.myshopify.com': {
    // Primary Index
    products: `products`,
    // sort options
    sortOptions: [
      {
        value: `products_newset`, // this is not a typo. The algolia index is called 'newset'
        label: `Date Added (Newest - Oldest)`
      },
      {
        value: `products_price_ascending`,
        label: `Purchase Price - Low to High`,
      },
      {
        value: `products_price_descending`,
        label: `Purchase Price - High to Low`,
      },
      {
        value: `products_au_A-Z`,
        label: `Product Title, A-Z`
      },
      {
        value: `products_au_Z-A`,
        label: `Product Title, Z-A`
      }
    ],
    // Replica Indices
    products_price_ascending: `products_price_ascending`,
    products_price_descending: `products_price_descending`,
    products_newest: `products_newset`,
    // Page Index
    pages: `pages`,
    // Article Index
    articles: `articles`,
    collections: `collections`
  },
  'silverchef-nz.myshopify.com': {
    // Primary Image
    products: `shopify_nz_products`,
    // sort options
    sortOptions: [
      {
        value: `shopify_nz_products_newset`, // this is not a typo. The algolia index is called 'newset'
        label: `Date Added (Newest - Oldest)`
      },
      {
        value: `shopify_nz_products_price_ascending`,
        label: `Purchase Price - Low to High`,
      },
      {
        value: `shopify_nz_products_price_descending`,
        label: `Purchase Price - High to Low`,
      },
      {
        value: `shopify_nz_products_A-Z`,
        label: `Product Title, A-Z`
      },
      {
        value: `shopify_nz_products_Z-A`,
        label: `Product Title, Z-A`
      }
    ],
    // Replica Indices
    products_price_ascending: `shopify_nz_products_price_ascending`,
    products_price_descending: `shopify_nz_products_price_descending`,
    products_newest: `shopify_nz_products_newset`,
    // Page Index
    pages: `pages`,
    // Article Index
    articles: `articles`,
    collections: `shopify_nz_collections`
  },
  'silverchef-ca.myshopify.com': {
    // Primary Index
    products: `shopify_ca_products`,
    // sort options
    sortOptions: [
      {
        value: `shopify_ca_products_newset`, // this is not a typo. The algolia index is called 'newset'
        label: `Date Added (Newest - Oldest)`
      },
      {
        value: `shopify_ca_products_price_ascending`,
        label: `Purchase Price - Low to High`,
      },
      {
        value: `shopify_ca_products_price_descending`,
        label: `Purchase Price - High to Low`,
      },
      {
        value: `shopify_ca_products_A-Z`,
        label: `Product Title, A-Z`
      },
      {
        value: `shopify_ca_products_Z-A`,
        label: `Product Title, Z-A`
      }
    ],
    // Replica Indices
    products_price_ascending: `shopify_ca_products_price_ascending`,
    products_price_descending: `shopify_ca_products_price_descending`,
    products_newest: `shopify_ca_products_newset`,
    // Pages Index
    pages: `pages`,
    // Article Index
    articles: `articles`,
    collections: `shopify_ca_collections`
  },
  'silverchef-staging-au.myshopify.com': {
    // Primary Index
    products: `staging_au_products`,
    // sort options
    sortOptions: [
      {
        value: `staging_au_products_newest`,
        label: `Date Added (Newest - Oldest)`
      },
      {
        value: `staging_au_products_price_descending`,
        label: `Purchase Price - High to Low`,
      },
      {
        value: `staging_au_products_A-Z`,
        label: `Product Title, A-Z`
      },
      {
        value: `staging_au_products_Z-A`,
        label: `Product Title, Z-A`
      }
    ],
    // Replica Indices
    products_price_ascending: `staging_au_products_price_ascending`,
    products_price_descending: `staging_au_products_price_descending`,
    products_newest: `staging_au_products_newest`,
    // Page Index
    pages: `pages`,
    // Article Index
    articles: `articles`,
    collections: `staging_au_collections`
  },
  'silverchef-staging-ca.myshopify.com': {
    // Primary Index
    products: `staging_ca_products`,
    // sort options
    sortOptions: [
      {
        value: `staging_ca_products_newest`,
        label: `Date Added (Newest - Oldest)`
      },
      {
        value: `staging_ca_products_price_asc`,
        label: `Purchase Price - Low to High`,
      },
      {
        value: `staging_ca_products_price_descending`,
        label: `Purchase Price - High to Low`,
      },
      {
        value: `staging_ca_products_A-Z`,
        label: `Product Title, A-Z`
      },
      {
        value: `staging_ca_products_Z-A`,
        label: `Product Title, Z-A`
      }
    ],
    // Replica Indices
    products_price_ascending: `staging_ca_products_price_asc`,
    products_price_descending: `staging_ca_products_price_descending`,
    products_newest: `staging_ca_products_newest`,
    // Pages Index
    pages: `staging_ca_pages`,
    // Article Index
    articles: `staging_ca_articles`,
    collections: `staging_ca_collections`
  },
  'silverchef-staging-nz.myshopify.com': {
    // Primary Index
    products: `stagingnz_products`,
    // Sort options
    sortOptions: [
      {
        value: `stagingnz_products_newest`,
        label: `Date Added (Newest - Oldest)`
      },
      {
        value: `stagingnz_products_price_ascending`,
        label: `Purchase Price - Low to High`,
      },
      {
        value: `stagingnz_products_price_descending`,
        label: `Purchase Price - High to Low`,
      },
      {
        value: `stagingnz_products_A-Z`,
        label: `Product Title, A-Z`
      },
      {
        value: `stagingnz_products_Z-A`,
        label: `Product Title, Z-A`
      }
    ],
    // Replica Indices
    products_price_ascending: `stagingnz_products_price_ascending`,
    products_price_descending: `stagingnz_products_price_descending`,
    products_newest: `stagingnz_products_newest`,
    // Pages Index
    pages: `stagingnz_pages`,
    // Article Index
    articles: `stagingnz_articles`,
    collections: `stagingnz_collections`
  },
  'silverchef-test.myshopify.com': {
    // Primary Index
    products: `sc_test_au_products`,
    // Sort options
    sortOptions: [
      {
        value: `sc_test_au_products_sort_newest`,
        label: `Date Added (Newest - Oldest)`
      },
      {
        value: `sc_test_au_products_sort_price_asc`,
        label: `Purchase Price - Low to High`,
      },
      {
        value: `sc_test_au_products_sort_price_desc`,
        label: `Purchase Price - High to Low`,
      },
      {
        value: `sc_test_au_products_A-Z`,
        label: `Product Title, A-Z`
      },
      {
        value: `sc_test_au_products_Z-A`,
        label: `Product Title, Z-A`
      }
    ],
    // Replica Indices
    products_price_ascending: `sc_test_au_products_sort_price_asc`,
    products_price_descending: `sc_test_au_products_sort_price_desc`,
    products_newest: `sc_test_au_products_sort_newest`,
    // Page Index
    pages: `sc_test_au_pages`,
    // Article Index
    articles: `sc_test_au_articles`,
    collections: `sc_test_au_collections`
  },
  'silverchef-ca-test.myshopify.com':  {
    // Primary Index
    products: `ca_testproducts`,
    // Sort options
    sortOptions: [
      {
        value: `ca_testproducts_newest`,
        label: `Date Added (Newest - Oldest)`
      },
      {
        value: `ca_test_products_price_ascending`,
        label: `Purchase Price - Low to High`,
      },
      {
        value: `ca_test_products_price_descending`,
        label: `Purchase Price - High to Low`,
      },
      {
        value: `ca_testproducts`,
        label: `Product Title, A-Z`
      },
      {
        value: `ca_testproducts`,
        label: `Product Title, Z-A`
      }
    ],
    // Replica Indices
    products_price_ascending: `ca_test_products_price_ascending`,
    products_price_descending: `ca_test_products_price_descending`,
    products_newest: `ca_testproducts_newest`,
    // Page Index
    pages: `ca_testpages`,
    // Article Index
    articles: `ca_testarticles`,
    collections: `ca_testcollections`
  },
  'silverchef-nz-test.myshopify.com':  {
    // Primary Index
    products: `nz_test_products`,
    // Sort options
    sortOptions: [
      {
        value: `nz_test_products_newest`,
        label: `Date Added (Newest - Oldest)`
      },
      {
        value: `nz_test_products_price_ascending`,
        label: `Purchase Price - Low to High`,
      },
      {
        value: `nz_test_products_price_descending`,
        label: `Purchase Price - High to Low`,
      },
      {
        value: `nz_test_products`,
        label: `Product Title, A-Z`
      },
      {
        value: `nz_test_products`,
        label: `Product Title, Z-A`
      }
    ],
    // Replica Indices
    products_price_ascending: `nz_test_products_price_ascending`,
    products_price_descending: `nz_test_products_price_descending`,
    products_newest: `nz_test_products_newest`,
    // Page Index
    pages: `nz_test_pages`,
    // Article Index
    articles: `nz_test_articles`,
    collections: `nz_test_collections`
  }
}

export function getShopifyAlgoliaIndex() {
  return algoliaShopifyIndices[window.Shopify.shop] || algoliaShopifyIndices[`silverchef.myshopify.com`]
}

export function DetermineAlgoliaCountryTitle(country) {
  switch (country) {
    case `au_app`:
      return `Australia`
    case `ca_app`:
      return `Canada`
    case `nz_app`:
      return `New Zealand`
    default:
      return `Australia`
  }
}
